<div class="container-fluid h-100">
  <div class="row h-100">
    <as-split direction="horizontal" [gutterSize]="20">
      <as-split-area [size]="30" [order]="1">
        <div class="flex-column h-100 ml-4">
          <app-locations-list
            (selectLocation)="selectLocation($event)"
          ></app-locations-list>
        </div>
      </as-split-area>

      <as-split-area [size]="selectedLocation ? 40 : 70" [order]="2">
        <div class="flex-column h-100">
          <div *ngIf="selectedLocation" class="row h-100">
            <div class="col-12">
              <app-locations-map
                (itemsUpdated)="itemsUpdated($event)"
                [items]="items"
                [location]="selectedLocation"
                [hoveredItemId]="hoveredItemId"
                [selectedItems]="selectedItems"
              ></app-locations-map>
            </div>
          </div>
          <div *ngIf="!selectedLocation" class="row h-100">
            <div
              class="col-12 h-100 d-flex align-items-center justify-content-center"
            >
              {{ "messages.location.select" | translate }}
            </div>
          </div>
        </div>
      </as-split-area>

      <as-split-area [size]="30" [visible]="!!selectedLocation" [order]="3">
        <div class="flex-column h-100 mr-4">
          <div *ngIf="selectedLocation" class="h-100">
            <app-locations-items
              (itemsUpdated)="itemsUpdated($event)"
              (itemOnHover)="itemOnHover($event)"
              [location]="selectedLocation"
              (itemsSelectionChanged)="onItemsSelectionChanged($event)"
              [items]="items"
            ></app-locations-items>
          </div>
        </div>
      </as-split-area>
    </as-split>
  </div>
</div>
